// Copyright (c) 2015, salesforce.com, inc. All rights reserved.

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'

import {
  ProductCard,
  SpanWithData,
  NavLink
} from '../'


export class WithdrawalBatchCard extends React.PureComponent {
  static propTypes = {
    initiateOn: PropTypes.string,
    status: PropTypes.string,
    productName: PropTypes.string,
    workflowRun: PropTypes.object,
    detailLink: PropTypes.string,
    onDetailLinkClick: PropTypes.func,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    let {
      initiatedByName,
      initiateOn,
      initiateWorkflowAt,
      status,
      productName,
      workflowRun
    } = this.props

    let secondaryDetails = {
      'Initiate on': initiateOn
        ? moment(initiateOn).format('DD MMM YYYY')
        : '-',
      'Initiated by': initiatedByName,
      'Status': <SpanWithData
          forField='WithdrawalStatus'
          searchKey={status}
        />,
      'Product': productName,
      'Initiate workflow at': initiateWorkflowAt
        ? moment(initiateWorkflowAt).format('DD MMM YYYY HH:mm')
        : '-',
      'Workflow': workflowRun
        ? <NavLink to={`/os/operations/general/workflows/${workflowRun.id}`}>
            {workflowRun.description}
          </NavLink>
        : '-'
    }

    return (
      <ProductCard
        title='Withdrawal Batch'
        iconOverride={
          <Fragment>
            <Icon
              icon={faHandHoldingUsd}
              size='4x'
              className='slds-text-color_weak'
            />
            <Icon
              icon={faHandHoldingUsd}
              size='2x'
              className='slds-text-color_weak'
              style={{ transform: 'translate(1.65em, -1.9em)' }}
            />
          </Fragment>
        }
        secondaryDetails={secondaryDetails}
        titleClassName={null}
        hideFooter={true}
        className={`u-bg-color-white ${this.props.className}`}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-batch-card/index.js